<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Stock Check</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        :to="{name: 'stock-check-add'}"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        @click="count.show = true"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="view_list"
                    >Count</vs-button>
                    <!-- <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="filterInit"
                    >Filter</vs-button>
                    <vs-button
                        @click="exportData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="import_export"
                    >Export</vs-button> -->
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                rowSelection="single"
                :floatingFilter="false"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
        </vx-card>
        <vs-prompt
            @accept="searchCount"
            :active.sync="count.show"
            title="Count"
            >
            <div class="con-exemple-prompt">
                <div class="vx-col w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Stock Check ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="count.id" @keyup.enter="searchCount"/>
                        </div>
                    </div>
                </div>
                <vs-alert v-if="count.error" color="danger" vs-icon="new_releases" class="mt-5">
                    {{ count.error }}
                </vs-alert>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import vSelect from "vue-select";
import FileSaver from "file-saver";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            data: [],
            maxPageNumbers: 7,
            gridApi: null,
            isLoading: false,
            columnApi: null,
            showFilter: false,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            filter: {
                clientOptions: [],
                warehouseOptions: [],
                locationTypeOptions: [],
                locationOptions: [],
                productOptions: [],
                stockTypeOptions: [],
                client: null,
                warehouse: null,
                location_type: null,
                location: null,
                product: null,
                description: "",
                pack_id: "",
                batch: "",
                stock_type: null,
                storage_unit: ""
            },
            count: {
                show: false,
                id: '',
                error: ''
            },
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            selectedId: null
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        refreshData() {
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.$http.post('inventories/stockcheck?page=' + this.currentPage, this.filter)
            .then(res => {
                this.isLoading = false;
                this.totalPage = res.data.last_page;
                this.dataTotal = res.data.total;
                this.dataFrom = res.data.from;
                this.dataTo = res.data.to;
                this.data = res.data.data
            })
            .catch(error => {
                this.isLoading = false;
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: "Server Error",
                    text: "Try again?",
                    accept: () => {
                        this.fetchData();
                    },
                    acceptText: "Yes",
                    cancelText: "No"
                });
                return;
            })
        },
        filterInit() {
            this.isLoading = true;
            Promise.all([
                this.$http.post("master/clients/filter/dropdown"),
                this.$http.post("master/warehouses/filter/dropdown"),
                this.$http.post("master/locationtypes/filter/dropdown"),
                this.$http.post("master/locations/filter/dropdown"),
                this.$http.post("master/product/filter/dropdown"),
                this.$http.post("master/stocktypes/filter/dropdown")
            ])
                .then(
                    this.$http.spread(
                        (
                            clients,
                            warehouses,
                            locationtypes,
                            locations,
                            products,
                            stocktypes
                        ) => {
                            this.filter.clientOptions = clients.data;
                            this.filter.warehouseOptions = warehouses.data;
                            this.filter.locationTypeOptions =
                                locationtypes.data;
                            this.filter.locationOptions = locations.data;
                            this.filter.productOptions = products.data;
                            this.filter.stockTypeOptions = stocktypes.data;

                            this.showFilter = true;
                            this.isLoading = false;
                        }
                    )
                )
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.filterInit();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                });
        },
        filterData() {
            this.fetchData();
        },
        exportData() {
            this.isLoading = true;
            this.$http
                .get("inventories/inventorieslist/report/download_excel", {
                    responseType: "blob"
                })
                .then(res => {
                    this.isLoading = false;
                    FileSaver.saveAs(res.data, "inventory_export.xlsx");
                });
            // .then(response => response.blob())
            // .then(blob => {
            // saveAs(blob, 'inbound_export.xlsx')
        },
        viewData() {
            this.$router.push({
                name: 'stock-check-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        searchCount() {
            this.count.error = ''
            this.count.show = false
            if(!this.count.id) {
                this.count.error = 'Please fill stock check ID'
                this.count.show = true
                return false
            }
            else {
                this.isLoading = true
                this.$http.post('inventories/stockcheck/search', {id: this.count.id})
                .then(res => {
                    this.isLoading = false
                    this.$router.push({
                        name: 'stock-check-count',
                        params: {
                            id: res.data.id,
                        }
                    })
                })
                .catch(error => {
                    this.isLoading = false
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.count.error = message
                    this.count.show = true
                })
            }
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
        this.gridColumnApi = this.gridOptions.columnApi;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "ID",
                field: "id",
                width: 120
            },
            {
                headerName: "Reference",
                field: "reference",
                width: 120
            },
            {
                headerName: "Date",
                field: "check_date",
                width: 120
            },
            {
                headerName: "Warehouse ID",
                field: "warehouses_code",
                width: 120
            },
            {
                headerName: "Client ID",
                field: "client_code",
                width: 120
            },
            {
                headerName: "Count ID",
                field: "count_status",
                width: 120
            },
            {
                headerName: "Status",
                field: "status",
                width: 120
            },
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>